export default "__VITE_ASSET__DDbapOGd__"